import { render, staticRenderFns } from "./pushRecordList.vue?vue&type=template&id=5359be83&scoped=true"
import script from "./pushRecordList.vue?vue&type=script&lang=js"
export * from "./pushRecordList.vue?vue&type=script&lang=js"
import style0 from "./pushRecordList.vue?vue&type=style&index=0&id=5359be83&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5359be83",
  null
  
)

export default component.exports